module.exports = __webpack_public_path__ + "img/oman_icc.6d90fa85.png";